import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { Wallet, Transaction } from '@nimbazaar/types';
import type { RootState } from '../store';

interface WalletState {
  wallet: Wallet | null;
  transactions: Transaction[];
  isLoading: boolean;
  error: string | null;
}

const initialState: WalletState = {
  wallet: null,
  transactions: [],
  isLoading: false,
  error: null,
};

export const walletSlice = createSlice({
  name: 'wallet',
  initialState,
  reducers: {
    setWallet: (state, action: PayloadAction<Wallet>) => {
      state.wallet = action.payload;
      state.error = null;
    },
    updateBalance: (state, action: PayloadAction<number>) => {
      if (state.wallet) {
        state.wallet.balance = action.payload;
      }
    },
    setTransactions: (state, action: PayloadAction<Transaction[]>) => {
      state.transactions = action.payload;
    },
    addTransaction: (state, action: PayloadAction<Transaction>) => {
      state.transactions.unshift(action.payload);
      if (state.wallet) {
        state.wallet.balance = action.payload.balance;
      }
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    clearWallet: (state) => {
      state.wallet = null;
      state.transactions = [];
      state.error = null;
    },
  },
});

export const walletActions = walletSlice.actions;

// Selectors
export const selectWallet = (state: RootState) => state.wallet.wallet;
export const selectWalletBalance = (state: RootState) => state.wallet.wallet?.balance ?? 0;
export const selectTransactions = (state: RootState) => state.wallet.transactions;
export const selectWalletIsLoading = (state: RootState) => state.wallet.isLoading;
export const selectWalletError = (state: RootState) => state.wallet.error;
